import React from 'react';
import ProgressBar from 'scy/ProgressBar';
import { statusBackgroundStyles } from './helpers';
import { localizeNumber } from 'shared/utils';
import {
  sansSerifMedium,
  sansSerifLight,
  fontSizeXXS,
  lineHeightS,
  uppercase
} from 'scy/text/styles.mod.scss';
import { relative } from 'scy/position.mod.scss';
import styles from './styles.mod.scss';

export default function LoyaltyProgressSlider({
  currentPoints,
  nextStatus,
  statusTiers
}) {
  const finalStatus = statusTiers[statusTiers.length - 1];
  const finalPoints = finalStatus.point_value;
  const percentage =
    currentPoints >= finalPoints ? 100 : (100 * currentPoints) / finalPoints;
  const color = nextStatus.primary_color;

  return (
    <div className={relative}>
      <ProgressBar
        className={styles.progressSliderProgressBar}
        percentage={percentage}
        color={color}
      />
      {statusTiers.map(tier => (
        <StatusTier key={tier.name} tier={tier} finalPoints={finalPoints} />
      ))}
    </div>
  );
}

function StatusTier({ tier, finalPoints }) {
  const { point_value, primary_color } = tier;

  const backgroundStyle = {
    ...statusBackgroundStyles(tier, 'to bottom right'),
    left: `${(100 * point_value) / finalPoints}%`
  };

  return (
    <div className={styles.progressSliderMarker} style={backgroundStyle}>
      <div
        className={styles.progressSliderLabel}
        style={{ color: primary_color }}
      >
        <div
          className={`${sansSerifMedium} ${fontSizeXXS} ${lineHeightS} ${uppercase}`}
        >
          {tier.name}
        </div>
        <div className={`${sansSerifLight} ${fontSizeXXS}`}>
          {localizeNumber(tier.point_value)} pts
        </div>
      </div>
    </div>
  );
}
